import React, { useState } from 'react';
import AnimatedSection from '../components/AnimatedSection';
import { products } from '../data/content';

const Products = () => {
  // WhatsApp number - Replace with your actual WhatsApp number
  const whatsappNumber = "919886631818"; // Format: country code + number without '+' or spaces
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [emailForm, setEmailForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  // Function to generate WhatsApp link
  const getWhatsAppLink = (productTitle) => {
    const message = `Hi! I'm interested in your product "${productTitle}". Could you please provide more details, pricing, and demo information?`;
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
  };

  // Function to handle email enquiry
  const handleEmailEnquiry = (product) => {
    setSelectedProduct(product);
    setShowEmailModal(true);
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    const subject = `Product Enquiry: ${selectedProduct.title}`;
    const body = `Product: ${selectedProduct.title}\n\nCustomer Details:\nName: ${emailForm.name}\nEmail: ${emailForm.email}\nPhone: ${emailForm.phone}\n\nMessage:\n${emailForm.message}`;
    window.location.href = `mailto:info@vtechcoders.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    
    // Reset form and close modal
    setEmailForm({ name: '', email: '', phone: '', message: '' });
    setShowEmailModal(false);
    setSelectedProduct(null);
    
    // Show success message
    alert('Email client opened! Please send the email to complete your enquiry.');
  };

  return (
    <>
      <section style={{ padding: '5rem 0', position: 'relative', overflow: 'hidden' }}>
        {/* Animated Background Elements */}
        <div className="products-bg">
          <div className="bg-circle-1"></div>
          <div className="bg-circle-2"></div>
          <div className="bg-circle-3"></div>
        </div>

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <AnimatedSection animation="fade-up">
            <h2 className="section-title">Innovative Products</h2>
            <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '3rem' }}>
              Discover our cutting-edge solutions designed to transform your business
            </p>
          </AnimatedSection>
          
          <div className="products-grid">
            {products.map((product, idx) => (
              <AnimatedSection key={idx} animation="scale-up" delay={idx * 100}>
                <div 
                  className="product-card"
                  onMouseEnter={() => setHoveredProduct(idx)}
                  onMouseLeave={() => setHoveredProduct(null)}
                >
                  {/* Product Icon with Animation */}
                  <div className="product-icon-wrapper">
                    <div className="product-icon-glow"></div>
                    <div className="product-icon">
                      <i className={product.icon}></i>
                    </div>
                  </div>
                  
                  <h3>{product.title}</h3>
                  <p className="product-description">{product.description}</p>
                  
                  {/* Product Features */}
                  {product.features && (
                    <div className="product-features">
                      {product.features.map((feature, fIdx) => (
                        <div key={fIdx} className="feature-chip">
                          <i className="fas fa-star"></i>
                          <span>{feature}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  
                  {/* Pricing/Badge */}
                  {product.badge && (
                    <div className="product-badge">
                      <i className="fas fa-crown"></i>
                      <span>{product.badge}</span>
                    </div>
                  )}
                  
                  {/* Action Buttons */}
                  <div className="product-actions">
                    {/* WhatsApp Button */}
                    <a 
                      href={getWhatsAppLink(product.title)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="action-btn whatsapp-btn"
                    >
                      <span className="btn-icon-wrapper">
                        <i className="fab fa-whatsapp"></i>
                      </span>
                      <span className="btn-text">WhatsApp Enquiry</span>
                      <span className="btn-arrow">
                        <i className="fas fa-arrow-right"></i>
                      </span>
                    </a>
                    
                    {/* Email Button */}
                    <button 
                      onClick={() => handleEmailEnquiry(product)}
                      className="action-btn email-btn"
                    >
                      <span className="btn-icon-wrapper">
                        <i className="fas fa-envelope"></i>
                      </span>
                      <span className="btn-text">Email Enquiry</span>
                      <span className="btn-arrow">
                        <i className="fas fa-paper-plane"></i>
                      </span>
                    </button>
                  </div>
                  
                  {/* Hover Effect Overlay */}
                  <div className="card-overlay"></div>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </section>

      {/* Email Modal */}
      {showEmailModal && (
        <div className="modal-overlay" onClick={() => setShowEmailModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <div className="modal-title">
                <i className="fas fa-gem"></i>
                <h3>Enquire About {selectedProduct?.title}</h3>
              </div>
              <button className="modal-close" onClick={() => setShowEmailModal(false)}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            
            <form onSubmit={handleEmailSubmit} className="email-form">
              <div className="form-group">
                <label>
                  <i className="fas fa-user"></i>
                  Full Name *
                </label>
                <input
                  type="text"
                  placeholder="Enter your full name"
                  value={emailForm.name}
                  onChange={(e) => setEmailForm({...emailForm, name: e.target.value})}
                  required
                />
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>
                    <i className="fas fa-envelope"></i>
                    Email Address *
                  </label>
                  <input
                    type="email"
                    placeholder="Enter your email"
                    value={emailForm.email}
                    onChange={(e) => setEmailForm({...emailForm, email: e.target.value})}
                    required
                  />
                </div>
                
                <div className="form-group">
                  <label>
                    <i className="fas fa-phone"></i>
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    placeholder="Enter your phone number"
                    value={emailForm.phone}
                    onChange={(e) => setEmailForm({...emailForm, phone: e.target.value})}
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label>
                  <i className="fas fa-comment-dots"></i>
                  Your Message *
                </label>
                <textarea
                  rows="4"
                  placeholder="Tell us about your requirements, questions, or anything else..."
                  value={emailForm.message}
                  onChange={(e) => setEmailForm({...emailForm, message: e.target.value})}
                  required
                ></textarea>
              </div>
              
              <div className="modal-buttons">
                <button type="button" className="cancel-btn" onClick={() => setShowEmailModal(false)}>
                  Cancel
                </button>
                <button type="submit" className="submit-btn">
                  <i className="fas fa-paper-plane"></i>
                  Send Enquiry
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
        /* Animated Background */
        .products-bg {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          overflow: hidden;
          z-index: 0;
        }
        
        .bg-circle-1,
        .bg-circle-2,
        .bg-circle-3 {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          opacity: 0.3;
          animation: float 20s ease-in-out infinite;
        }
        
        .bg-circle-1 {
          width: 400px;
          height: 400px;
          background: radial-gradient(circle, #3b82f6, #8b5cf6);
          top: -200px;
          left: -200px;
          animation-delay: 0s;
        }
        
        .bg-circle-2 {
          width: 500px;
          height: 500px;
          background: radial-gradient(circle, #8b5cf6, #ec489a);
          bottom: -250px;
          right: -250px;
          animation-delay: -5s;
        }
        
        .bg-circle-3 {
          width: 300px;
          height: 300px;
          background: radial-gradient(circle, #06b6d4, #3b82f6);
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          animation-delay: -10s;
        }
        
        @keyframes float {
          0%, 100% {
            transform: translate(0, 0) scale(1);
          }
          33% {
            transform: translate(50px, -50px) scale(1.1);
          }
          66% {
            transform: translate(-50px, 50px) scale(0.9);
          }
        }
        
        /* Products Grid */
        .products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(340px, 1fr));
          gap: 2rem;
        }
        
        /* Product Card */
        .product-card {
          background: white;
          border-radius: 24px;
          padding: 2rem;
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
          transition: all 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
          border: 1px solid rgba(59, 130, 246, 0.1);
          position: relative;
          overflow: hidden;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .product-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(95deg, #3b82f6, #8b5cf6);
          transform: scaleX(0);
          transition: transform 0.4s ease;
        }
        
        .product-card:hover::before {
          transform: scaleX(1);
        }
        
        .product-card:hover {
          transform: translateY(-12px);
          box-shadow: 0 25px 40px rgba(0, 0, 0, 0.12);
          border-color: rgba(59, 130, 246, 0.3);
        }
        
        .card-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.02), rgba(139, 92, 246, 0.02));
          opacity: 0;
          transition: opacity 0.4s ease;
          pointer-events: none;
        }
        
        .product-card:hover .card-overlay {
          opacity: 1;
        }
        
        /* Product Icon */
        .product-icon-wrapper {
          position: relative;
          width: 100px;
          height: 100px;
          margin: 0 auto 1.5rem auto;
        }
        
        .product-icon-glow {
          position: absolute;
          inset: 0;
          background: radial-gradient(circle, rgba(59, 130, 246, 0.3), transparent);
          border-radius: 30px;
          opacity: 0;
          transition: opacity 0.4s ease;
        }
        
        .product-card:hover .product-icon-glow {
          opacity: 1;
          animation: pulse 2s ease-in-out infinite;
        }
        
        .product-icon {
          width: 100px;
          height: 100px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          border-radius: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.4s ease;
          position: relative;
          z-index: 1;
        }
        
        .product-card:hover .product-icon {
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.2), rgba(139, 92, 246, 0.2));
          transform: scale(1.05) rotate(5deg);
        }
        
        .product-icon i {
          font-size: 3rem;
          color: #3b82f6;
          transition: transform 0.4s ease;
        }
        
        .product-card:hover .product-icon i {
          transform: scale(1.1);
        }
        
        @keyframes pulse {
          0%, 100% {
            opacity: 0.5;
            transform: scale(1);
          }
          50% {
            opacity: 1;
            transform: scale(1.1);
          }
        }
        
        /* Title */
        h3 {
          font-size: 1.6rem;
          font-weight: 700;
          margin-bottom: 0.75rem;
          text-align: center;
          color: #1e293b;
          transition: all 0.3s ease;
        }
        
        .product-card:hover h3 {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        
        /* Description */
        .product-description {
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 1.5rem;
          text-align: center;
          font-size: 0.95rem;
        }
        
        /* Product Features */
        .product-features {
          display: flex;
          flex-wrap: wrap;
          gap: 0.5rem;
          justify-content: center;
          margin-bottom: 1.5rem;
        }
        
        .feature-chip {
          display: flex;
          align-items: center;
          gap: 6px;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          padding: 5px 12px;
          border-radius: 50px;
          font-size: 0.8rem;
          font-weight: 500;
          color: #3b82f6;
        }
        
        .feature-chip i {
          font-size: 0.7rem;
        }
        
        /* Product Badge */
        .product-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          background: linear-gradient(135deg, #f59e0b, #ef4444);
          padding: 8px 16px;
          border-radius: 50px;
          width: fit-content;
          margin: 0 auto 1.5rem auto;
          color: white;
          font-weight: 600;
          font-size: 0.85rem;
          animation: shine 2s ease-in-out infinite;
        }
        
        @keyframes shine {
          0%, 100% {
            box-shadow: 0 0 5px rgba(245, 158, 11, 0.5);
          }
          50% {
            box-shadow: 0 0 20px rgba(245, 158, 11, 0.8);
          }
        }
        
        /* Action Buttons */
        .product-actions {
          display: flex;
          flex-direction: column;
          gap: 0.8rem;
          margin-top: auto;
        }
        
        .action-btn {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 20px;
          border-radius: 50px;
          text-decoration: none;
          font-weight: 600;
          font-size: 0.9rem;
          transition: all 0.3s ease;
          cursor: pointer;
          border: none;
          position: relative;
          overflow: hidden;
        }
        
        .action-btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
          transition: left 0.5s ease;
        }
        
        .action-btn:hover::before {
          left: 100%;
        }
        
        .action-btn:hover {
          transform: translateY(-2px);
        }
        
        .btn-icon-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 50%;
          transition: all 0.3s ease;
        }
        
        .action-btn:hover .btn-icon-wrapper {
          transform: scale(1.1);
        }
        
        .btn-text {
          flex: 1;
          text-align: center;
          margin: 0 10px;
        }
        
        .btn-arrow {
          transition: transform 0.3s ease;
        }
        
        .action-btn:hover .btn-arrow {
          transform: translateX(5px);
        }
        
        .whatsapp-btn {
          background: linear-gradient(135deg, #25D366, #128C7E);
          color: white;
        }
        
        .whatsapp-btn:hover {
          box-shadow: 0 5px 15px rgba(37, 211, 102, 0.3);
        }
        
        .email-btn {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
        }
        
        .email-btn:hover {
          box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);
        }
        
        /* Modal Styles */
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.8);
          backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2000;
          animation: fadeIn 0.3s ease;
        }
        
        .modal-content {
          background: white;
          border-radius: 24px;
          max-width: 550px;
          width: 90%;
          max-height: 90vh;
          overflow-y: auto;
          animation: slideUp 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1);
        }
        
        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.5rem;
          border-bottom: 2px solid #e2e8f0;
          background: linear-gradient(135deg, rgba(59, 130, 246, 0.05), rgba(139, 92, 246, 0.05));
        }
        
        .modal-title {
          display: flex;
          align-items: center;
          gap: 12px;
        }
        
        .modal-title i {
          font-size: 1.5rem;
          color: #3b82f6;
        }
        
        .modal-title h3 {
          margin: 0;
          font-size: 1.3rem;
        }
        
        .modal-close {
          background: none;
          border: none;
          font-size: 1.2rem;
          cursor: pointer;
          color: #64748b;
          transition: all 0.3s ease;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .modal-close:hover {
          background: #ef4444;
          color: white;
          transform: rotate(90deg);
        }
        
        .email-form {
          padding: 1.5rem;
        }
        
        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
        }
        
        .form-group {
          margin-bottom: 1.2rem;
        }
        
        .form-group label {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #1e293b;
          font-size: 0.9rem;
        }
        
        .form-group input,
        .form-group textarea {
          width: 100%;
          padding: 12px 14px;
          border: 2px solid #e2e8f0;
          border-radius: 12px;
          font-family: inherit;
          transition: all 0.3s ease;
          font-size: 0.9rem;
        }
        
        .form-group input:focus,
        .form-group textarea:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
          transform: translateY(-2px);
        }
        
        .modal-buttons {
          display: flex;
          gap: 1rem;
          margin-top: 1.5rem;
        }
        
        .cancel-btn {
          flex: 1;
          padding: 12px;
          background: #e2e8f0;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          transition: all 0.3s ease;
        }
        
        .cancel-btn:hover {
          background: #cbd5e1;
          transform: translateY(-2px);
        }
        
        .submit-btn {
          flex: 1;
          padding: 12px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          border: none;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 600;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          transition: all 0.3s ease;
        }
        
        .submit-btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 15px rgba(59, 130, 246, 0.3);
        }
        
        /* Animations */
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        
        @keyframes slideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        /* Responsive Styles */
        @media (max-width: 768px) {
          .products-grid {
            grid-template-columns: 1fr;
          }
          
          .product-card {
            padding: 1.5rem;
          }
          
          .product-icon-wrapper,
          .product-icon {
            width: 80px;
            height: 80px;
          }
          
          .product-icon i {
            font-size: 2.2rem;
          }
          
          h3 {
            font-size: 1.3rem;
          }
          
          .form-row {
            grid-template-columns: 1fr;
            gap: 0;
          }
          
          .modal-content {
            width: 95%;
          }
        }
        
        /* Dark Mode Support */
        @media (prefers-color-scheme: dark) {
          .product-card {
            background: rgba(30, 41, 59, 0.9);
            border-color: rgba(59, 130, 246, 0.2);
          }
          
          h3 {
            color: #f1f5f9;
          }
          
          .product-description {
            color: #94a3b8;
          }
          
          .modal-content {
            background: #1e293b;
          }
          
          .modal-header {
            border-bottom-color: #334155;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(139, 92, 246, 0.1));
          }
          
          .form-group label {
            color: #f1f5f9;
          }
          
          .form-group input,
          .form-group textarea {
            background: #0f172a;
            border-color: #334155;
            color: white;
          }
          
          .cancel-btn {
            background: #334155;
            color: white;
          }
        }
      `}</style>
    </>
  );
};

export default Products;